module.exports = {
    'shieldWords': ['军','监狱','监所','看守所','狱','监','执法','办案','公安','执法办案','昆山市'],
}


// WEBPACK FOOTER //
// ./src/assets/js/shield.js